<mat-card class="bg-grey-button award-endorsement-card">
  <mat-card-header>
    <mat-card-title>
      {{ acknowledgementTitle }}
    </mat-card-title>
  </mat-card-header>

  @if (form) {
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submitForm()">
        <p class="intro">
          Please review and acknowledge the
          {{ semesterLabel }} {{ programTypeLabel }} award amount being
          disbursed to the school.
        </p>

        <section class="award-summary">
          <div class="summary-row">
            <span class="summary-label">Student</span>

            <span
              class="summary-value"
              [attr.data-pw]="controlIdPrefix + '-student-name'"
              [attr.data-qa]="controlIdPrefix + '-student-name'">
              {{ form.get('studentName')?.value }}
            </span>
          </div>

          <div class="summary-row">
            <span class="summary-label">School Name</span>

            <span
              class="summary-value"
              [attr.data-pw]="controlIdPrefix + '-school-name'"
              [attr.data-qa]="controlIdPrefix + '-school-name'">
              {{ form.get('schoolName')?.value }}
            </span>
          </div>

          <div class="summary-row award-amount">
            <span class="summary-label">
              {{ awardAmountLabel }}
            </span>

            <span
              class="summary-value"
              [attr.data-pw]="controlIdPrefix + '-amount'"
              [attr.data-qa]="controlIdPrefix + '-amount'">
              {{ form.get('awardAmount')?.value | currency }}
            </span>
          </div>
        </section>

        <mat-checkbox
          class="acknowledgement"
          formControlName="certified"
          [id]="controlIdPrefix + '-certified'"
          [attr.data-pw]="controlIdPrefix + '-certified'"
          [attr.data-qa]="controlIdPrefix + '-certified'"
          [attr.aria-label]="acknowledgementText">
          {{ acknowledgementText }}
        </mat-checkbox>

        @if (!isReadOnly) {
          <div class="actions">
            <button
              mat-button
              type="button"
              [id]="controlIdPrefix + '-back'"
              [attr.data-pw]="controlIdPrefix + '-back'"
              [attr.data-qa]="controlIdPrefix + '-back'"
              aria-label="Back"
              (click)="onBack()">
              Back
            </button>

            <button
              mat-stroked-button
              color="primary"
              type="submit"
              [id]="controlIdPrefix + '-submit'"
              [attr.data-pw]="controlIdPrefix + '-submit'"
              [attr.data-qa]="controlIdPrefix + '-submit'"
              [attr.aria-label]="'Submit ' + acknowledgementTitle"
              [disabled]="!isFormReady()">
              Submit
            </button>
          </div>
        }
      </form>
    </mat-card-content>
  }
</mat-card>